import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mv-chat-header" }
const _hoisted_2 = {
  class: "mv-item-av-wrap",
  style: {"margin":"0 6px 0 2px","position":"relative","flex-shrink":"0"}
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mv-chat-hinfo" }
const _hoisted_6 = { class: "mv-chat-hname" }
const _hoisted_7 = {
  key: 0,
  class: "mv-chat-hdoc"
}
const _hoisted_8 = {
  key: 1,
  class: "mv-chat-hphone"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_11 = {
  key: 1,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "mv-chat-hsub" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "mv-chat-action-bar" }
const _hoisted_16 = { class: "mv-sdot-label" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#9CA3AF",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_20 = { class: "mv-chat-agent-name" }
const _hoisted_21 = { class: "mv-chat-lbls-wrap" }
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 1,
  class: "mv-snooze-banner"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }

import { ref, computed } from 'vue'
import type { Conversation, Assignee } from '@/types/dashboard'
import type { SLABadge } from '@/types/chat'
import { avatarColor, initials, conversationDocument } from '@/composables/useHelpers'
import { dotClass, convStatusLabel } from '@/utils/mobileFormat'
import { fmtPhone } from '@/utils/contactsFormat'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileChatHeader',
  props: {
    conv: {},
    macroSheetOpen: { type: Boolean },
    assignee: {},
    currentLabels: {},
    updatingLabels: { type: Boolean },
    activeSlaBadge: {},
    snoozeRemainingLabel: {}
  },
  emits: ["back", "open-msg-search", "open-macro-sheet", "toggle-status-menu", "open-agent-sheet", "toggle-labels", "toggle-label"],
  setup(__props: any) {

const props = __props

const convDocument = computed(() => conversationDocument(props.conv))

// Mesmo padrão de copiar (ícone → check verde por 2s) já usado em
// ConvDrawer.vue/AvatarPopup.vue no desktop.
const phoneCopied = ref(false)
async function copyPhone() {
  const phone = props.conv.contact.phone
  if (!phone) return
  await navigator.clipboard.writeText(phone)
  phoneCopied.value = true
  setTimeout(() => { phoneCopied.value = false }, 2000)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("button", {
        class: "mv-icon-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
        title: "Voltar"
      }, [...(_cache[11] || (_cache[11] = [
        _createElementVNode("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
        ], -1)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "mv-chat-av",
          style: _normalizeStyle({ background: _unref(avatarColor)(__props.conv.contact.name) })
        }, [
          (__props.conv.contact.thumbnail)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.conv.contact.thumbnail,
                alt: __props.conv.contact.name,
                onError: _cache[1] || (_cache[1] = (e) => (e.target as HTMLImageElement).style.display='none')
              }, null, 40, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(initials)(__props.conv.contact.name)), 1))
        ], 4),
        _createElementVNode("span", {
          class: _normalizeClass(["mv-status-dot sm", _unref(dotClass)(__props.conv)])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.conv.contact.name), 1),
        (convDocument.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(convDocument.value.label) + ": " + _toDisplayString(convDocument.value.value), 1))
          : _createCommentVNode("", true),
        (__props.conv.contact.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_unref(fmtPhone)(__props.conv.contact.phone)), 1),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["mv-phone-btn", { 'is-copied': phoneCopied.value }]),
                onClick: _withModifiers(copyPhone, ["stop"]),
                title: phoneCopied.value ? 'Copiado!' : 'Copiar número'
              }, [
                (phoneCopied.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("rect", {
                        x: "9",
                        y: "9",
                        width: "13",
                        height: "13",
                        rx: "2"
                      }, null, -1),
                      _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                    ]))]))
              ], 10, _hoisted_9),
              _createElementVNode("a", {
                class: "mv-phone-btn mv-phone-call",
                href: `tel:${__props.conv.contact.phone}`,
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                title: "Ligar"
              }, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("svg", {
                  width: "10",
                  height: "10",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.4",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13 19.79 19.79 0 0 1 1.61 4.44 2 2 0 0 1 3.59 2.24h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" })
                ], -1)
              ]))], 8, _hoisted_12)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (__props.conv.team)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(__props.conv.team.name) + " · ", 1))
            : _createCommentVNode("", true),
          _createTextVNode("#" + _toDisplayString(__props.conv.id), 1)
        ])
      ]),
      _createElementVNode("button", {
        class: "mv-icon-btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('open-msg-search'))),
        title: "Buscar nas mensagens"
      }, [...(_cache[15] || (_cache[15] = [
        _createElementVNode("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("circle", {
            cx: "11",
            cy: "11",
            r: "8"
          }),
          _createElementVNode("line", {
            x1: "21",
            y1: "21",
            x2: "16.65",
            y2: "16.65"
          })
        ], -1)
      ]))]),
      _createElementVNode("button", {
        class: _normalizeClass(["mv-icon-btn", { 'mv-icon-btn--active': __props.macroSheetOpen }]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('open-macro-sheet'))),
        title: "Macros"
      }, [...(_cache[16] || (_cache[16] = [
        _createElementVNode("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
        ], -1)
      ]))], 2)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", {
        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("button", {
          class: "mv-chat-status-btn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle-status-menu')))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["mv-sdot", __props.conv.status])
          }, null, 2),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(convStatusLabel)(__props.conv.status)), 1),
          _cache[17] || (_cache[17] = _createElementVNode("svg", {
            width: "10",
            height: "10",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
          ], -1))
        ])
      ]),
      _createElementVNode("div", {
        onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("button", {
          class: "mv-chat-agent-btn",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('open-agent-sheet')))
        }, [
          _createElementVNode("div", {
            class: "mv-chat-agent-av",
            style: _normalizeStyle({ background: __props.assignee ? _unref(avatarColor)(__props.assignee.name) : '#D1D5DB' })
          }, [
            (__props.assignee?.thumbnail)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: __props.assignee.thumbnail,
                  alt: __props.assignee.name,
                  onError: _cache[7] || (_cache[7] = (e) => (e.target as HTMLImageElement).style.display='none')
                }, null, 40, _hoisted_17))
              : (__props.assignee)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(initials)(__props.assignee.name)), 1))
                : (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }, null, -1),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "7",
                      r: "4"
                    }, null, -1)
                  ]))]))
          ], 4),
          _createElementVNode("span", _hoisted_20, _toDisplayString(__props.assignee?.name ?? 'agente'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currentLabels, (l) => {
          return (_openBlock(), _createElementBlock("span", {
            key: l,
            class: "mv-lbl-chip"
          }, [
            _createTextVNode(_toDisplayString(l.replace(/_/g, ' ')) + " ", 1),
            _createElementVNode("button", {
              class: "mv-lbl-chip-x",
              onClick: _withModifiers(($event: any) => (_ctx.$emit('toggle-label', l)), ["stop"]),
              disabled: __props.updatingLabels
            }, "×", 8, _hoisted_22)
          ]))
        }), 128)),
        _createElementVNode("button", {
          class: "mv-lbl-add",
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.$emit('toggle-labels')), ["stop"])),
          disabled: __props.updatingLabels
        }, [...(_cache[19] || (_cache[19] = [
          _createElementVNode("svg", {
            width: "9",
            height: "9",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "3.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("line", {
              x1: "12",
              y1: "5",
              x2: "12",
              y2: "19"
            }),
            _createElementVNode("line", {
              x1: "5",
              y1: "12",
              x2: "19",
              y2: "12"
            })
          ], -1),
          _createTextVNode(" etiqueta ", -1)
        ]))], 8, _hoisted_23)
      ])
    ]),
    (__props.activeSlaBadge)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['mv-sla-banner', __props.activeSlaBadge.status])
        }, [
          _cache[20] || (_cache[20] = _createElementVNode("svg", {
            width: "11",
            height: "11",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }),
            _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
          ], -1)),
          _createElementVNode("strong", null, _toDisplayString(__props.activeSlaBadge.time), 1),
          _createElementVNode("span", null, "· SLA " + _toDisplayString(__props.activeSlaBadge.label) + _toDisplayString(__props.activeSlaBadge.status === 'breached' ? ' em atraso' : ' em risco'), 1)
        ], 2))
      : _createCommentVNode("", true),
    (__props.conv.status === 'snoozed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _cache[21] || (_cache[21] = _createElementVNode("svg", {
            width: "11",
            height: "11",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }),
            _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
          ], -1)),
          (__props.snoozeRemainingLabel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Adiado — " + _toDisplayString(__props.snoozeRemainingLabel) + " restantes", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_26, "Adiado até próxima resposta do cliente"))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})